module.exports = __webpack_public_path__ + "img/title.80261486.png";